/* ============================================================================
   product-blocks.js
   Extracted from sections/product-blocks.liquid on 2026-04-16
   All functions scoped to the PDP block section.
   Uses class selectors (not section.id) so it can be cached statically.
   ============================================================================ */

/* --- Variant selection handler --- */
/* Our own handler because Prestige's ProductVariants2 crashes on our custom markup */
(function() {
  var section = document.querySelector('.Product--blocks');
  if (!section) return;

  var productJsonEl = section.querySelector('[data-product-json]');
  if (!productJsonEl) return;
  var data = JSON.parse(productJsonEl.textContent);
  var product = data.product;
  var variants = product.variants;

  var select = section.querySelector('select[name="id"]');
  if (!select) return;

  var moneyFmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '£{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100);
    /* Remove trailing zeros: £175.00 → £175, £58.33 → £58.33 */
    var str = (amount % 1 === 0) ? amount.toFixed(0) : amount.toFixed(2);
    return moneyFmt.replace('{{amount}}', str).replace('{{amount_no_decimals}}', Math.round(amount));
  }

  function getSelectedOptions() {
    var opts = [];
    var groups = section.querySelectorAll('.ProductForm__Option');
    groups.forEach(function(group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) {
        var pos = parseInt(checked.getAttribute('data-option-position'));
        opts[pos - 1] = checked.value;
      }
    });
    return opts;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] && v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateSizeAvailability(opts) {
    /* When colour changes, update which sizes are available */
    var sizeGroup = section.querySelector('.swatches-size');
    if (!sizeGroup) return;
    var sizeRadios = sizeGroup.querySelectorAll('.SizeSwatch__Radio');
    sizeRadios.forEach(function(radio) {
      var testOpts = opts.slice();
      /* Find which position is the size option */
      var pos = parseInt(radio.getAttribute('data-option-position')) - 1;
      testOpts[pos] = radio.value;
      /* Check if any variant with these options is available */
      var available = false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < testOpts.length; j++) {
          if (testOpts[j] && v.options[j] !== testOpts[j]) { match = false; break; }
        }
        if (match && v.available) { available = true; break; }
      }
      var label = radio.nextElementSibling;
      if (available) {
        radio.disabled = false;
        if (label) label.classList.remove('SizeSwatch--unavailable');
      } else {
        radio.disabled = true;
        if (label) label.classList.add('SizeSwatch--unavailable');
      }
    });
  }

  function onVariantChange(e) {
    var opts = getSelectedOptions();

    /* If a colour changed, update size availability */
    if (e && e.target && e.target.classList.contains('ColorSwatch__Radio')) {
      updateSizeAvailability(opts);
      /* Update colour label */
      var colorLabel = section.querySelector('.ProductForm__SelectedValue');
      if (colorLabel) colorLabel.textContent = e.target.value;
    }

    var variant = findVariant(opts);
    if (!variant) return;

    /* Update hidden select */
    select.value = variant.id;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    /* Update price */
    var priceEl = section.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
    var compareEl = section.querySelector('.Price--compareAt');
    var discountEl = section.querySelector('.discount-text');

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (priceEl) priceEl.classList.add('Price--highlight');
      if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
      if (discountEl) {
        var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        discountEl.textContent = '[-' + pct + '%]';
        discountEl.style.display = '';
      }
    } else {
      if (priceEl) priceEl.classList.remove('Price--highlight');
      if (compareEl) compareEl.style.display = 'none';
      if (discountEl) discountEl.style.display = 'none';
    }

    /* Update ATC button */
    var atcBtn = section.querySelector('.ProductForm__AddToCart');
    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.setAttribute('data-action', 'add-to-cart');
        var label = (window.languages && window.languages.productFormAddToCart) || 'Add to Bag';
        atcBtn.innerHTML = '<span>' + label + '</span>';
      } else {
        atcBtn.disabled = true;
        atcBtn.removeAttribute('data-action');
        atcBtn.textContent = (window.languages && window.languages.productFormSoldOut) || 'Sold Out';
      }
    }

    /* Update stock block */
    var stockBlock = section.querySelector('.ag-stock-block');
    if (stockBlock) {
      var inStockLine = stockBlock.querySelector('.ag-stock-line:not(.ag-stock-line--low):not(.ag-stock-line--oos)');
      var lowStockLine = stockBlock.querySelector('.ag-stock-line--low');
      var oosLine = stockBlock.querySelector('.ag-stock-line--oos');

      if (variant.available) {
        if (inStockLine) inStockLine.style.display = '';
        if (oosLine) oosLine.style.display = 'none';
      } else {
        if (inStockLine) inStockLine.style.display = 'none';
        if (lowStockLine) lowStockLine.style.display = 'none';
        if (!oosLine) {
          oosLine = document.createElement('span');
          oosLine.className = 'ag-stock-line ag-stock-line--oos';
          oosLine.innerHTML = '<span class="stock-dot stock-dot--oos"></span><span class="stock-text" style="color:#ef4444;">Sold Out</span>';
          stockBlock.appendChild(oosLine);
        }
        oosLine.style.display = '';
      }
    }

    /* Update sticky ATC */
    var stickyBtn = document.querySelector('.StickyATC__Btn');
    if (stickyBtn) {
      stickyBtn.textContent = variant.available
        ? ((window.languages && window.languages.productFormAddToCart) || 'Add to Bag')
        : ((window.languages && window.languages.productFormSoldOut) || 'Sold Out');
    }

    /* Update URL */
    if (history.replaceState) {
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    /* Update payment info line (Klarna instalment price) */
    var paymentLine = section.querySelector('.payment-info-line');
    if (paymentLine) {
      var instalment = formatMoney(Math.round(variant.price / 3));
      var strong = paymentLine.querySelector('strong');
      if (strong) strong.textContent = instalment;
    }
  }

  /* Attach listeners */
  var radios = section.querySelectorAll('.SizeSwatch__Radio, .ColorSwatch__Radio');
  radios.forEach(function(r) {
    r.addEventListener('change', onVariantChange);
  });

  /* Handle initial variant from URL */
  var urlParams = new URLSearchParams(window.location.search);
  var urlVariantId = urlParams.get('variant');
  if (urlVariantId) {
    var urlVariant = variants.find(function(v) { return v.id.toString() === urlVariantId; });
    if (urlVariant) {
      /* Set the correct radios */
      urlVariant.options.forEach(function(optVal, idx) {
        var radio = section.querySelector('input[type="radio"][data-option-position="' + (idx + 1) + '"][value="' + CSS.escape(optVal) + '"]');
        if (radio) radio.checked = true;
      });
      select.value = urlVariant.id;
      updateSizeAvailability(urlVariant.options);
    }
  } else {
    /* Initial size availability based on default selected colour */
    var initialOpts = getSelectedOptions();
    if (initialOpts.length > 0) updateSizeAvailability(initialOpts);
  }
})();

/* --- Low stock indicator --- */
/* Low stock indicator — updates on variant change */
(function() {
  var el = document.querySelector('[data-low-stock]');
  if (!el) return;
  var threshold = parseInt(el.dataset.threshold) || 5;
  var textEl = el.querySelector('.ag-low-stock__text');
  var inv = {};
  el.dataset.inventory.split(',').forEach(function(pair) {
    var p = pair.split(':');
    if (p.length === 2) inv[p[0]] = parseInt(p[1]);
  });

  function update() {
    var select = document.querySelector('[name="id"]');
    if (!select) return;
    var vid = select.value;
    var qty = inv[vid];
    if (qty > 0 && qty < threshold) {
      textEl.textContent = 'Only ' + qty + (qty === 1 ? ' piece' : ' pieces') + ' left';
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }

  update();
  /* Listen for Prestige variant change events */
  var radios = document.querySelectorAll('.SizeSwatch__Radio, .ColorSwatch__Radio');
  radios.forEach(function(r) { r.addEventListener('change', function() { setTimeout(update, 50); }); });
  /* Also observe the hidden select for programmatic changes */
  var select = document.querySelector('[name="id"]');
  if (select) {
    var observer = new MutationObserver(function() { update(); });
    observer.observe(select, { attributes: true, childList: true, subtree: true });
    select.addEventListener('change', update);
  }
})();

/* --- Judge.me badge visibility ---
   Badge is hidden via CSS by default to prevent "No reviews" flash.
   Poll until Judge.me populates it, then show only if reviews > 0. */
(function() {
  var badge = document.querySelector('.pdp-reviews-snippet.jdgm-preview-badge');
  if (!badge) return;

  var attempts = 0;
  function check() {
    attempts++;
    var inner = badge.querySelector('.jdgm-prev-badge');
    if (inner) {
      var count = parseInt(inner.getAttribute('data-number-of-reviews') || '0', 10);
      if (count > 0) {
        badge.style.visibility = 'visible';
      }
      /* 0 reviews: leave hidden */
      return;
    }
    if (attempts < 40) setTimeout(check, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(check, 500); });
  } else {
    setTimeout(check, 500);
  }
})();

/* --- UK delivery countdown --- */
/* UK delivery countdown — 3pm cutoff, Mon-Fri */
(function() {
  var el = document.querySelector('.ag-delivery-countdown');
  if (!el) return;

  var cutoff = el.dataset.cutoff || '15:00';
  var parts = cutoff.split(':');
  var cutoffHour = parseInt(parts[0]);
  var cutoffMin = parseInt(parts[1] || 0);
  var tplBefore = el.dataset.nextDay;
  var tplAfter = el.dataset.after;

  function update() {
    var now = new Date();
    /* Convert to UK time */
    var uk = new Date(now.toLocaleString('en-GB', { timeZone: 'Europe/London' }));
    var day = uk.getDay(); /* 0=Sun, 6=Sat */
    var isWeekday = day >= 1 && day <= 5;
    var cutoffToday = new Date(uk);
    cutoffToday.setHours(cutoffHour, cutoffMin, 0, 0);
    var diff = cutoffToday - uk;

    if (isWeekday && diff > 0) {
      /* Before cutoff on a weekday — show countdown */
      var hrs = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var timeStr = '';
      if (hrs > 0) timeStr += hrs + 'h ';
      timeStr += mins + 'm';
      el.innerHTML = tplBefore.replace('{time}', timeStr);
    } else {
      /* After cutoff or weekend */
      el.innerHTML = tplAfter;
    }
  }

  update();
  setInterval(update, 60000);
})();

/* --- Gallery + lightbox + drawers + smart header + sidebar + sticky ATC --- */
/* Gallery navigation */
(function() {
  var gallery = document.querySelector('.pdp-gallery');
  if (!gallery) return;
  var slides = gallery.querySelectorAll('.pdp-gallery__slide');
  var total = slides.length;
  if (total <= 1) return;
  var current = 0;
  var btns = gallery.querySelectorAll('.pdp-gallery__btn');
  var counter = gallery.querySelector('[data-current]');
  window._galleryIdx = 0;
  var isMobile = function() { return window.innerWidth <= 750; };

  function updateUI(idx) {
    current = idx;
    window._galleryIdx = idx;
    if (counter) counter.textContent = idx + 1;
    if (btns.length >= 2) {
      btns[0].disabled = (idx === 0);
      btns[1].disabled = (idx >= total - 1);
    }
  }

  function goTo(idx) {
    if (idx < 0 || idx >= total) return;
    if (isMobile()) {
      gallery.scrollTo({ left: idx * gallery.offsetWidth, behavior: 'smooth' });
    } else {
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      slides[idx].classList.add('is-active');
    }
    updateUI(idx);
  }

  /* Arrow clicks */
  if (btns.length >= 2) {
    btns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        goTo(current + parseInt(btn.dataset.dir));
      });
    });
  }

  /* Track scroll position (mobile swipe) */
  var scrollTimer;
  gallery.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
      if (!isMobile()) return;
      var w = gallery.offsetWidth;
      if (w > 0) {
        var idx = Math.round(gallery.scrollLeft / w);
        if (idx !== current && idx >= 0 && idx < total) updateUI(idx);
      }
    }, 80);
  });

  updateUI(0);

  /* Mobile: hide counter + zoom when gallery not visible */
  if (isMobile()) {
    var zoomBtn = gallery.querySelector('.pdp-gallery__zoom');
    var counterEl = gallery.querySelector('.pdp-gallery__counter');
    
    /* Move counter + zoom outside the scroll container into a wrapper */
    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-gallery__overlay';
    gallery.parentNode.insertBefore(wrapper, gallery);
    wrapper.appendChild(gallery);
    if (counterEl) wrapper.appendChild(counterEl);
    if (zoomBtn) wrapper.appendChild(zoomBtn);

    var galleryObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        var visible = e.isIntersecting ? 'visible' : 'hidden';
        if (zoomBtn) zoomBtn.style.visibility = visible;
        if (counterEl) counterEl.style.visibility = visible;
      });
    }, { threshold: 0.1 });
    galleryObs.observe(gallery);
  }
})();

/* Lightbox — vertical scroll on all devices */
function openLightbox() {
  var lb = document.getElementById('pdpLightbox');
  lb.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  var idx = window._galleryIdx || 0;
  var target = lb.querySelector('[data-lb-slide="' + idx + '"]');
  if (target) setTimeout(function() { target.scrollIntoView({ behavior: 'smooth' }); }, 50);
}
function closeLightbox() {
  document.getElementById('pdpLightbox').classList.remove('is-open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeLightbox(); });

function toggleDrawer(panelId, btn) {
  var panel = document.getElementById(panelId);
  var section = panel.closest('section');
  section.querySelectorAll('.BlockDrawer__Panel').forEach(function(p) {
    if (p.id !== panelId) {
      p.classList.remove('is-open');
      p.style.maxHeight = '';
      var s = p.querySelector('.BlockDrawer__Scroll');
      if (s) s.style.maxHeight = '';
    }
  });
  section.querySelectorAll('.DrawerIcon__Vert').forEach(function(v) { v.style.opacity = '1'; v.style.transform = 'translate(-50%,-50%)'; });
  panel.classList.toggle('is-open');
  var vert = btn.querySelector('.DrawerIcon__Vert');
  if (panel.classList.contains('is-open')) {
    if (vert) { vert.style.opacity = '0'; vert.style.transform = 'translate(-50%,-50%) rotate(90deg)'; }
    /* Desktop: scroll to top, then open drawer with full height */
    if (window.innerWidth > 750) {
      var header = document.getElementById('shopify-section-header');
      var section = panel.closest('section');
      var headerH = header ? header.offsetHeight : 0;
      var sectionTop = section.getBoundingClientRect().top + window.pageYOffset - headerH;
      var needsScroll = Math.abs(window.pageYOffset - sectionTop) > 50;

      if (needsScroll) {
        /* Remove is-open temporarily — we'll re-add after scroll */
        panel.classList.remove('is-open');
        window.scrollTo({ top: Math.max(0, sectionTop), behavior: 'smooth' });

        setTimeout(function() {
          var triggerBar = btn.closest('.BlockDrawer__TriggerBar');
          var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
          var triggerTop = triggerBar ? triggerBar.getBoundingClientRect().top : 0;
          var available = triggerTop - headerBottom - 8;
          if (available > 100) {
            panel.style.maxHeight = available + 'px';
            var scroll = panel.querySelector('.BlockDrawer__Scroll');
            if (scroll) scroll.style.maxHeight = (available - 20) + 'px';
          }
          panel.classList.add('is-open');
        }, 250);
      } else {
        /* Already near top — just calc and open */
        var triggerBar = btn.closest('.BlockDrawer__TriggerBar');
        var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        var triggerTop = triggerBar ? triggerBar.getBoundingClientRect().top : 0;
        var available = triggerTop - headerBottom - 8;
        if (available > 100) {
          panel.style.maxHeight = available + 'px';
          var scroll = panel.querySelector('.BlockDrawer__Scroll');
          if (scroll) scroll.style.maxHeight = (available - 20) + 'px';
        }
      }
    }
  } else {
    if (vert) { vert.style.opacity = '1'; vert.style.transform = 'translate(-50%,-50%)'; }
    panel.style.maxHeight = '';
    var scroll = panel.querySelector('.BlockDrawer__Scroll');
    if (scroll) scroll.style.maxHeight = '';
  }
}
function closeDrawer(panelId) {
  var panel = document.getElementById(panelId);
  panel.classList.remove('is-open');
  panel.style.maxHeight = '';
  var scroll = panel.querySelector('.BlockDrawer__Scroll');
  if (scroll) scroll.style.maxHeight = '';
  panel.closest('section').querySelectorAll('.DrawerIcon__Vert').forEach(function(v) { v.style.opacity = '1'; v.style.transform = 'translate(-50%,-50%)'; });
}
function closeDrawerMobile(panelId) {
  closeDrawer(panelId);
  if (window.innerWidth > 750) return;
  var triggers = document.querySelector('.BlockDrawer__TriggerBar');
  if (!triggers) return;
  setTimeout(function() {
    var top = triggers.getBoundingClientRect().top + window.pageYOffset - 60;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }, 400);
}

/* Smart header — hide on scroll down, show on scroll up + transparent/solid */
(function() {
  var header = document.getElementById('shopify-section-header');
  if (!header) return;
  var gallery = document.querySelector('.pdp-gallery');
  var lastScroll = 0;
  var threshold = 80;
  window.addEventListener('scroll', function() {
    var current = window.pageYOffset;

    /* Hide/show */
    if (current <= threshold) {
      header.classList.remove('header--hidden');
    } else if (current > lastScroll) {
      header.classList.add('header--hidden');
    } else {
      header.classList.remove('header--hidden');
    }
    lastScroll = current;

    /* Transparent over gallery, solid past it */
    if (gallery) {
      var galleryBottom = gallery.getBoundingClientRect().bottom;
      if (galleryBottom <= 0) {
        header.classList.add('header--solid');
      } else {
        header.classList.remove('header--solid');
      }
    }
  });
})();

/* Sidebar height — match gallery so accordion sits at bottom */
(function() {
  if (window.innerWidth <= 750) return;
  var gallery = document.querySelector('.pdp-gallery');
  var sidebar = document.querySelector('.Product--blocks .Product__InfoWrapper');
  if (!gallery || !sidebar) return;
  function match() {
    if (window.innerWidth > 750) {
      sidebar.style.minHeight = gallery.offsetHeight + 'px';
    } else {
      sidebar.style.minHeight = '';
    }
  }
  match();
  window.addEventListener('resize', match);
  /* Re-check after images load */
  window.addEventListener('load', match);
})();

/* Sticky mobile ATC — shows when real ATC is out of view */
(function() {
  if (window.innerWidth > 750) return;
  var realBtn = document.querySelector('.Product--blocks .add-to-cart-button');
  var stickyBar = document.querySelector('.StickyATC');
  var stickyBtn = document.querySelector('.StickyATC__Btn');
  if (!realBtn || !stickyBar || !stickyBtn) return;

  /* Click sticky → trigger real ATC */
  stickyBtn.addEventListener('click', function() {
    var realSubmit = realBtn.querySelector('.ProductForm__AddToCart');
    if (realSubmit && !realSubmit.disabled) realSubmit.click();
  });

  /* Observe real ATC visibility — fade out as it approaches */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        stickyBar.classList.add('is-fading');
        setTimeout(function() { stickyBar.classList.remove('is-visible'); }, 300);
      } else {
        stickyBar.classList.remove('is-fading');
        stickyBar.classList.add('is-visible');
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px 60px 0px' });

  observer.observe(realBtn);
})();

/* --- AJAX Add-to-Cart handler ---
   Prestige's ProductSection init crashes on our custom gallery markup,
   so the theme's built-in ATC listener never binds. We handle it ourselves. */
(function() {
  var section = document.querySelector('.Product--blocks');
  if (!section) return;

  var form = section.querySelector('form[action="/cart/add"]');
  if (!form) return;

  var isSubmitting = false;

  function openCartDrawer() {
    /* Prestige uses aria-hidden on #sidebar-cart + PageOverlay */
    var sidebar = document.getElementById('sidebar-cart');
    if (sidebar) {
      sidebar.setAttribute('aria-hidden', 'false');
      /* Prestige also toggles body class */
      document.body.classList.add('no-scroll');
    }
    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.add('is-visible');

    /* Dispatch Prestige's internal event so the theme JS can react */
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function updateCartCount(count) {
    /* Update all cart count badges on the page */
    document.querySelectorAll('.Header__CartCount').forEach(function(el) {
      el.textContent = count;
    });
    /* Also update any data attribute the theme checks */
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.setAttribute('data-cart-count', count);
      if (count > 0) el.classList.remove('is-hidden');
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    isSubmitting = true;

    var atcBtn = form.querySelector('.ProductForm__AddToCart');
    var originalHTML = atcBtn ? atcBtn.innerHTML : '';
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.innerHTML = '<span>Adding…</span>';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Add to cart failed: ' + resp.status);
      return resp.json();
    })
    .then(function() {
      /* Fetch updated cart for count */
      return fetch('/cart.js', { credentials: 'same-origin' });
    })
    .then(function(resp) { return resp.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);

      /* Reload sidebar-cart HTML so line items are fresh */
      var sidebar = document.getElementById('sidebar-cart');
      if (sidebar) {
        fetch('/?section_id=sidebar-cart', { credentials: 'same-origin' })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('sidebar-cart');
            if (fresh) sidebar.innerHTML = fresh.innerHTML;
            openCartDrawer();
          })
          .catch(function() { openCartDrawer(); });
      } else {
        openCartDrawer();
      }
    })
    .catch(function(err) {
      console.error('[AG ATC]', err);
      /* Fallback: native form submit */
      form.submit();
    })
    .finally(function() {
      isSubmitting = false;
      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.innerHTML = originalHTML;
      }
    });
  }

  /* Intercept form submit */
  form.addEventListener('submit', handleSubmit);
})();

/* --- Wishlist heart — move inline with Klarna/payment line --- */
(function() {
  var section = document.querySelector('.Product--blocks');
  if (!section) return;

  function moveWishlist() {
    var wishlist = section.querySelector('wishlist-button-product');
    if (!wishlist) return;
    var paymentLine = section.querySelector('.payment-info-line');
    if (paymentLine && !paymentLine.contains(wishlist)) {
      paymentLine.appendChild(wishlist);
      /* Stop clicks on the heart from bubbling to the payment modal trigger */
      wishlist.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  }

  moveWishlist();
  var attempts = 0;
  var poll = setInterval(function() {
    attempts++;
    moveWishlist();
    if (section.querySelector('.payment-info-line wishlist-button-product') || attempts > 20) {
      clearInterval(poll);
    }
  }, 500);
})();
